import { useMutation } from '@tanstack/react-query';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';
import { message } from 'antd';
import { QUERY_KEYS } from '@/utils/query-keys';
import { queryClient } from '@/store/query';
interface CreateSurveyAnswerParams {
	survey_id: string;
	participation_id: string;
	question_id: string;
	option_id?: string;
	response?: string;
}

const Service = PsychosocialReportService.getInstance();

export const useCreateSurveyAnswer = () => {
	return useMutation({
		mutationFn: (params: CreateSurveyAnswerParams) => Service.createSurveyAnswer(params),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_PSYCHOSOCIAL_PARTICIPATION_ANSWERS] });
		},
		onError: (_) => {
			message.error('Error saving answer');
		}
	});
};
